import { ReactElement, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { calculateTotalBcrs, calculateTotalBcrsDeposit } from "../../../common/helpers/bcrsHelper";
import { centsToDollarsDisplay } from "../../../common/helpers/stringUtils";
import Condition from "../../../components/Conditional/Condition";
import I18nText from "../../../components/I18nText/I18nText";
import { useCartContext } from "../../../contexts/CartServiceContext/CartServiceContext";
import { useConfigContext } from "../../../contexts/ConfigContext/ConfigContext";

const CartBcrsItem = (): ReactElement => {
	const { t } = useTranslation();

	const { state: cart } = useCartContext((state) => state.cart);
	const { state: bcrs_deposit_rate } = useConfigContext((state) => state.config.bcrs_deposit_rate);

	// Calculate total BCRS deposit amount using helper
	const bcrsDepositAmount = useMemo(() => {
		return calculateTotalBcrsDeposit(cart, bcrs_deposit_rate);
	}, [cart, bcrs_deposit_rate]);

	const totalBcrs = useMemo(() => {
		return calculateTotalBcrs(cart);
	}, [cart]);

	return (
		<Condition check={totalBcrs > 0}>
			<li className="CartItem CartBcrsItem">
				<div className="ItemHeader">
					<span className="ItemNameText">{t("cartPage.bcrs.totalDeposit")}</span>
					<div className="ItemHeaderRight">
						<span className="Price TabularNums">{`$${centsToDollarsDisplay(bcrsDepositAmount)}`}</span>
					</div>
				</div>
				<div className="ItemContents">
					<span className="BcrsDisclaimer">{t("cartPage.bcrs.disclaimer")}</span>
				</div>
			</li>
		</Condition>
	);
};

export default CartBcrsItem;
